import type { QueryClient } from '@tanstack/react-query';
import type { AnyRouter } from '@tanstack/react-router';
import { setUnauthorizedListener } from '@/lib/api';
import { meQueryKey } from './session';

// Session expiry (07 S00 «sessione scaduta»): the first 401 from any API call
// while someone was signed in drops the session and sends them to the login
// with the way back, so after signing in they return where they were.

export function installSessionWatch(queryClient: QueryClient, router: AnyRouter): void {
  setUnauthorizedListener(() => {
    const signedIn = queryClient.getQueryData(meQueryKey);
    if (!signedIn) return;
    queryClient.setQueryData(meQueryKey, null);
    const here = router.state.location;
    if (here.pathname === '/login') return;
    void router.navigate({
      to: '/login',
      search: { reason: 'expired', redirect: here.href },
      replace: true,
    });
  });
}
